import { format, startOfDay } from "date-fns";
import { addLocale, locale } from "primereact/api";
import { createContext, useContext, useEffect, useState } from "react";
import logoColorido from "../assets/logo-azulescura.png";
import logoBranco from "../assets/logo-gradiente.png";
import { carregaLayout, carregaLayoutURL } from "../services/requests/getLayoutInfo";
import { useAuth } from "./AuthInfoContext";
//import classNames from "classnames";

const InfoContext = createContext({});

function GeneralInfo({ children }) {
  //const URL = 'caema.cotapay.com.br'
  //const URL = 'apepa.paguedireto.com.br'
  const URL = window.location.hostname;
  const avenidaDominio = URL.includes("avenida");

  const { provider_id } = useAuth();
  const [today] = useState(startOfDay(new Date()));
  const [corGradiente1, setCorGradiente1] = useState("#011728");
  const [corGradiente2, setCorGradiente2] = useState("#011728");
  const [corGradiente3, setCorGradiente3] = useState("#011728");
  const [corCard1, setCorCard1] = useState("#012440");
  const [corCard2, setCorCard2] = useState("#213f58");
  const [corFonte, setCorFonte] = useState("#ffffff");
  const [corFonte2, setCorFonte2] = useState("#4aa677");
  // const [corTabelaTitulo,setCorTabelaTitulo] = useState('#213b50');
  // const [corTabelaConteudo,setCorTabelaConteudo] = useState('#011b30');
  const [frontImage, setFrontImage] = useState("pagina_login_plataforma_whitelabel.png");
  const [logoImage, setLogoImage] = useState(logoBranco);
  const [tituloPagina, setTituloPagina] = useState("Negocie Direto");
  const [corTextoBotao, setCorTextoBotao] = useState("#ffffff");
  const [mostrarLogo, setMostrarLogo] = useState(false);
  const [mostrarFooter, setMostrarFooter] = useState(false);
  const [diretoLogoClaro, setDiretoLogoClaro] = useState(true);
  const [pagueDiretoLogo, setPagueDiretoLogo] = useState(logoBranco);
  const [iconePagina, setIconePagina] = useState("/Flavicon-Direto-48x48-1.png");
  const [erroConexaoBackEnd, setErroConexaoBackEnd] = useState(false);
  const [mensagemHome, setMensagemHome] = useState(relogio() + " aqui ajudamos você a quitar o seu débito");
  //
  const [reloadLayout, setReloadLayout] = useState(false);
  const [loadLayout, setLoadLayout] = useState(false);

  addLocale("pt-BR", {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"],
    dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    today: "Hoje",
    clear: "Claro",
  });
  locale("pt-BR");

  function relogio() {
    const hora = new Date().getHours();
    if (hora >= 5 && hora < 12) return "Bom dia,";
    if (hora >= 12 && hora < 18) return "Boa tarde,";
    return "Boa noite,";
  }

  function carregaTema(layout) {
    //console.log(layout)
    setCorGradiente1(`#${layout.cor_gradiente1}`);
    setCorGradiente2(`#${layout.cor_gradiente2}`);
    setCorGradiente3(`#${layout.cor_gradiente3}`);
    setCorCard1(`#${layout.cor_card1}`);
    setCorCard2(`#${layout.cor_card2}`);
    setCorFonte(`#${layout.cor_fonte}`);
    setCorFonte2(`#${layout.cor_fonte_2}`);
    setCorTextoBotao(`#${layout.texto_botao_cor}`);
    setFrontImage(layout.front_link);
    setLogoImage(layout.logo_link);
    setTituloPagina(layout.titulo_pagina);
    setMostrarLogo(layout.mostrar_logo);
    setMostrarFooter(layout.mostrar_footer);
    setDiretoLogoClaro(layout.logo_direto_claro);
    setPagueDiretoLogo(layout.logo_direto_claro ? logoBranco : logoColorido);
    setErroConexaoBackEnd(false);
    setMensagemHome(layout.mensagem_pagina || relogio() + " aqui ajudamos você a quitar o seu débito");
    document.documentElement.style.setProperty("--background-card-2", `#${layout.cor_card2}`);
    document.documentElement.style.setProperty("--input-shadows", `#${layout.sombra_botao_cor1}60 4px 4px 0px 0px`);
    document.documentElement.style.setProperty("--generic-font-color", `#${layout.cor_fonte}`);
    document.documentElement.style.setProperty("--generic-button-color-text", `#${layout.texto_botao_cor}`);
    document.documentElement.style.setProperty("--generic-button-color-shadow", `#${layout.sombra_botao_cor1}85`);
    document.documentElement.style.setProperty(
      "--generic-button-color",
      `linear-gradient(#${layout.gradiente_botao_cor1},#${layout.gradiente_botao_cor2})`
    );
    document.documentElement.style.setProperty(
      "--generic-button-color-hover",
      `linear-gradient(#${layout.hover_botao_cor1},#${layout.hover_botao_cor2})`
    );
    document.documentElement.style.setProperty("--generic-dropdown-color-focus", `#${layout.gradiente_botao_cor1}70`);
    document.documentElement.style.setProperty("--generic-dropdown-color-hover", `#${layout.gradiente_botao_cor1}40`);
    document.documentElement.style.setProperty("--generic-table-head-color", `#${layout.cor_tabela_titulo}`);
    document.documentElement.style.setProperty("--generic-table-content-color", `#${layout.cor_tabela_conteudo}`);
  }

  function carregaTemaPadrao() {
    setCorGradiente1("#011728");
    setCorGradiente2("#011728");
    setCorGradiente3("#011728");
    setCorCard1("#012440");
    setCorCard2("#213f58");
    setCorFonte("#ffffff");
    setCorFonte2("#4aa677");
    setCorTextoBotao("#ffffff");
    setFrontImage("pagina_login_plataforma_whitelabel.png");
    setLogoImage(logoBranco);
    setTituloPagina("Negocie Direto");
    setMostrarLogo(false);
    setMostrarFooter(true);
    setDiretoLogoClaro(true);
    setPagueDiretoLogo(logoBranco);
    setIconePagina("/Flavicon-Direto-48x48-1.png");
    setMensagemHome(relogio() + " aqui ajudamos você a quitar o seu débito");
    document.documentElement.style.setProperty("--background-card-2", `#D9D9D9`);
    document.documentElement.style.setProperty("--input-shadows", "#86868660 4px 4px 0px 0px");
    document.documentElement.style.setProperty("--generic-font-color", `#ffffff`);
    document.documentElement.style.setProperty("--generic-button-color-text", "#ffffff");
    document.documentElement.style.setProperty("--generic-button-color-shadow", "#86868685");
    document.documentElement.style.setProperty("--generic-button-color", "linear-gradient(#4aa677,#4aa677)");
    document.documentElement.style.setProperty("--generic-button-color-hover", "linear-gradient(#99c475,#99c475)");
    document.documentElement.style.setProperty("--generic-dropdown-color-focus", `#4aa677`);
    document.documentElement.style.setProperty("--generic-dropdown-color-hover", `#4aa677`);
    document.documentElement.style.setProperty("--generic-table-head-color", `#213b50`);
    document.documentElement.style.setProperty("--generic-table-content-color", `#011b30`);
  }

  useEffect(() => {
    async function carregaInfoCustomizacao() {
      setIconePagina("/Flavicon-Direto-48x48-1.png");
      try {
        let layoutInfo = [];
        let tema_ativo = [];
        if (window.location.pathname === "/") {
          layoutInfo = await carregaLayoutURL(URL);
          tema_ativo = layoutInfo.tema_credor.filter((item) => item.customizacao_status === true);
          if (tema_ativo.length === 0) carregaTemaPadrao();
        } else {
          layoutInfo = await carregaLayout(provider_id);
          tema_ativo = layoutInfo.temas.filter((item) => item.customizacao_status === true);
        }
        if (tema_ativo.length > 0 || tema_ativo === undefined) {
          carregaTema(tema_ativo[0]);
        } else carregaTemaPadrao();
      } catch (error) {
        console.log(error);
        setErroConexaoBackEnd(!error.response ? true : false);
        if (error.response) carregaTemaPadrao();
      } finally {
        setLoadLayout(true);
      }
    }
    carregaInfoCustomizacao();
  }, [reloadLayout]);

  return (
    <InfoContext.Provider
      value={{
        today,
        setReloadLayout,
        loadLayout,
        corGradiente1,
        corGradiente2,
        corGradiente3,
        corCard1,
        corCard2,
        corFonte,
        corFonte2,
        corTextoBotao,
        mostrarLogo,
        mostrarFooter,
        diretoLogoClaro,
        frontImage,
        logoImage,
        tituloPagina,
        avenidaDominio,
        pagueDiretoLogo,
        iconePagina,
        erroConexaoBackEnd,
        mensagemHome,
      }}
    >
      {children}
    </InfoContext.Provider>
  );
}

function useGeneral() {
  const context = useContext(InfoContext);
  return context;
}

export { GeneralInfo, useGeneral };
